
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index8B_RgENPYmRVm6YgfAdrxsisd7HziGT1AmiQGo7Fl40Meta } from "/opt/buildhome/repo/apps/console/pages/index.vue?macro=true";
import { default as influencing_45claims7P_45fQTPMzNRVG8bjF_450RIFlIa_IrZNx7RnCE2QV3kFEMeta } from "/opt/buildhome/repo/apps/console/pages/claims/[id]/[insightId]/influencing-claims.vue?macro=true";
import { default as _91id_93G_tSX8e6JciSzKw6t9jgH5v5OUQFUl95VG_1lnjyX28Meta } from "/opt/buildhome/repo/apps/console/pages/claims/[id].vue?macro=true";
import { default as claims9XgPTkogohNAfyx87Twt85q7h3lY87GJdYkEyeSdi70Meta } from "/opt/buildhome/repo/apps/console/pages/claims.vue?macro=true";
import { default as welcomea7_oKU1KpJgwNR_45v5XqnM0k53iWR5WMlxqKeP2Azy3QMeta } from "/opt/buildhome/repo/apps/console/pages/welcome.vue?macro=true";
import { default as edit_45modes8UNPjnrLWCfiYh_456PqzvZH1qSgaR3L3mvtzYJ4MVYW8Meta } from "/opt/buildhome/repo/apps/console/pages/policies/[id]/edit-modes.vue?macro=true";
import { default as providers_45impacted5aWRtZE00wQfYoAh3lCaUoSUoTobxfUruJdCBNpimsIMeta } from "/opt/buildhome/repo/apps/console/pages/policies/[id]/providers-impacted.vue?macro=true";
import { default as _91id_93_45D6P3lJmAuWSAjCcipSBkmm9sHyBtMr2wTgC4PzLCvMMeta } from "/opt/buildhome/repo/apps/console/pages/policies/[id].vue?macro=true";
import { default as index9oQK0_mXYqPguPNYr8UVEniM7jkvhUOUykiHDFxcilIMeta } from "/opt/buildhome/repo/apps/console/pages/policies/index.vue?macro=true";
import { default as policies49aZSYT3wSBIR_9E72mjq2rOiFsBfXw_45qUY2sAnVyVsMeta } from "/opt/buildhome/repo/apps/console/pages/policies.vue?macro=true";
import { default as changelogt0YH_456FtAcTmyiKADiWTBiO8Q5mgj7V6nvPAZSmz7_YMeta } from "/opt/buildhome/repo/apps/console/pages/changelog.vue?macro=true";
import { default as app_45status4_45mCrI6Eo41iOEeBD920FPPSdyXxfqlp8XyEC1TIm7EMeta } from "/opt/buildhome/repo/apps/console/pages/app-status.vue?macro=true";
import { default as indexUIXvmavsPM5Q8xc9WDJeD8wUuxwkSrF_451pU3w1YJS1sMeta } from "/opt/buildhome/repo/apps/console/pages/exclusions/index.vue?macro=true";
import { default as createKefaGeoyL3FOwj7GCah4lAqK_9o09R4tULxqqW21B9sMeta } from "/opt/buildhome/repo/apps/console/pages/exclusions/create.vue?macro=true";
import { default as edit0h5S3QhI_45lHkidV6aIUWcYjmPCEsUsclkGPLCeQQZL8Meta } from "/opt/buildhome/repo/apps/console/pages/exclusions/[id]/edit.vue?macro=true";
import { default as indexColiJcyFdAMg3nQK0hIO6ytNvrYQnMsADetGWlj82j4Meta } from "/opt/buildhome/repo/apps/console/pages/exclusions/[id]/index.vue?macro=true";
import { default as exclusionsOf0Z66avlKLdSxTFDW4Ub_6EogJtCMGED5ZA3nf3xMYMeta } from "/opt/buildhome/repo/apps/console/pages/exclusions.vue?macro=true";
import { default as create_45workspacet_45M3WklfcXo8HoA8R_ntEqF_451XMTwt52dCUkwl6QhzUMeta } from "/opt/buildhome/repo/apps/console/pages/admin/index/create-workspace.vue?macro=true";
import { default as indexN8nA7obtLcYaJOfYzvi2rjWW0ipDWe_454B1E1mDUZ4ocMeta } from "/opt/buildhome/repo/apps/console/pages/admin/index.vue?macro=true";
import { default as usersX5ckjacvzxUYx0_45TjbTwEYqiM_455J47qOTvfikcs4qsMMeta } from "/opt/buildhome/repo/apps/console/pages/admin/users.vue?macro=true";
import { default as maintenanceSTLYaBEvR7Ok_7I7KTbB_23y3AWGSCYalNiJDzHcCrUMeta } from "/opt/buildhome/repo/apps/console/pages/maintenance.vue?macro=true";
import { default as indexv7WXZb_45LGstRNOWOGupziyvF7qJsfVyMeFFjde_cyooMeta } from "/opt/buildhome/repo/apps/console/pages/[connectorId]/claim-lab/index.vue?macro=true";
import { default as _91rid_93FAVztuVrZRnW_45aTSK8wDSG5wyW2tTSc9zlj15dt_BVcMeta } from "/opt/buildhome/repo/apps/claim-lab/pages/[connectorId]/claim-lab/[claimId]/[rid].vue?macro=true";
import { default as _91rid_93KkStUjosmYhKm4UmnjH3T8_H_V_grgKin58VALfOQMIMeta } from "/opt/buildhome/repo/apps/claim-lab/pages/[connectorId]/claim-lab/[claimId]/v2/[rid].vue?macro=true";
import { default as _91connectorId_93U0TatuW0wffS81HsBs_luBbuZp7lt6Kkw_45s86ckvbHgMeta } from "/opt/buildhome/repo/apps/claim-lab/pages/[connectorId].vue?macro=true";
import { default as indexfYvy8GRk_w4yVSgDg87JvqkvcxYrExeH9IXiLqRKMSQMeta } from "/opt/buildhome/repo/apps/console/pages/account/index.vue?macro=true";
import { default as usersDMxviKARAq43c6oJBcW75_BVGsyiNKNA5l4q2H9nixIMeta } from "/opt/buildhome/repo/apps/console/pages/account/users.vue?macro=true";
import { default as api_45admin7kN5LSCREX600_YBE3ZALBbcBaZkc7422c94Gr8OGCUMeta } from "/opt/buildhome/repo/apps/console/pages/admin/api-admin.vue?macro=true";
import { default as indexDTgmlSr_45hOL3HEVH74EnR7mace4RjBWzZinmfjKOFOkMeta } from "/opt/buildhome/repo/apps/console/pages/dashboard/index.vue?macro=true";
import { default as app_45config_Uu_EtjreTriHAx7K5LYmD7HOA_45i8j8S_45Bw6yqSicHMMeta } from "/opt/buildhome/repo/apps/console/pages/admin/app-config.vue?macro=true";
import { default as _91id_937rgB7bRJG5x32HSkszZUVPZhhcQaa_nSICn3WUwd98UMeta } from "/opt/buildhome/repo/apps/console/pages/dashboard/policies/[id].vue?macro=true";
import { default as policies1Q4jJxJfl06eD_45otAgf8tVxEvLi47qAR0L9c7Y0NLiQMeta } from "/opt/buildhome/repo/apps/console/pages/dashboard/policies.vue?macro=true";
import { default as api_45clientsZCaKP1RxHw1kpj_9p9rzlTGrf_xdarbyVHK2CKETbpMMeta } from "/opt/buildhome/repo/apps/console/pages/account/api-clients.vue?macro=true";
import { default as editszz8RS4gvBQCJfwPkXw0RumA2ODdXYE9QGk1lTSIkKUMeta } from "/opt/buildhome/repo/apps/console/pages/admin/workspace/[id]/index/edit.vue?macro=true";
import { default as indexHEVGI_iRGohZSKgylrq0N56cap_45RmOfrkZV8Hz_T9JsMeta } from "/opt/buildhome/repo/apps/console/pages/admin/workspace/[id]/index/connector/index.vue?macro=true";
import { default as _91connId_93nKg4vygcPiDFR8_aLNO0kQ9vzofxUJUjeJBCpJacQvwMeta } from "/opt/buildhome/repo/apps/console/pages/admin/workspace/[id]/index/connector/[connId].vue?macro=true";
import { default as indexk6CbaYftFE57PA4KUK21Jy2b8i_45pmLg_45bG4M2LJiwUkMeta } from "/opt/buildhome/repo/apps/console/pages/admin/workspace/[id]/index.vue?macro=true";
import { default as _91id_93QpBcCbPIBHqZFUtSGZwclo2H_45RED0HqlM2FndVvgTFEMeta } from "/opt/buildhome/repo/apps/console/pages/admin/workspace/[id].vue?macro=true";
import { default as indexEfG4fXJr_45PvDe00Xs0zxf97CCHIzKi60QmPGkdJ3_45ZIMeta } from "/opt/buildhome/repo/apps/console/pages/dashboard/exclusions/[id]/index.vue?macro=true";
import { default as exclusionsu5Tg5lm4w5rAfAnHtCKdFlussXl5cycOkXr3FhFv_98Meta } from "/opt/buildhome/repo/apps/console/pages/dashboard/exclusions.vue?macro=true";
import { default as indexNC2qBDKoWLkn7K9gvLNL2ZxVwFJQr4lz3Y_45cEaj7KUcMeta } from "/opt/buildhome/repo/apps/console/pages/admin/workspace/index.vue?macro=true";
import { default as claim_45searchUBPrJWw1E9WXzEjV48VvnvrZswNEERd6LZuPQZs15IEMeta } from "/opt/buildhome/repo/apps/console/pages/dashboard/claim-search.vue?macro=true";
import { default as legalPXftdPkBk4BVypl5py2UNHmdRg_Jq1p0tUV3uPR7_7EMeta } from "/opt/buildhome/repo/packages/nuxt-auth0/src/runtime/pages/legal.vue?macro=true";
import { default as auth_45callbackOwXTNdlq9Gi79MczYvxUrBewH5fePFqTW3S9Tb8NMpUMeta } from "/opt/buildhome/repo/packages/nuxt-auth0/src/runtime/pages/auth-callback.vue?macro=true";
import { default as auth_45loginLiuJ2aewqsIckj_8LP8r_45y2kg1aevC0phvVWWA5JLrQMeta } from "/opt/buildhome/repo/packages/nuxt-auth0/src/runtime/pages/auth-login.vue?macro=true";
import { default as auth_45statusdBnapL4nk9x52YjfnhmjwWHCTdX0TwuPmC1g8zjGa4kMeta } from "/opt/buildhome/repo/packages/nuxt-auth0/src/runtime/pages/auth-status.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(index8B_RgENPYmRVm6YgfAdrxsisd7HziGT1AmiQGo7Fl40Meta || {}), ...{"middleware":"connector-required"} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/index.vue")
  },
  {
    name: "claims",
    path: "/claims",
    meta: { ...(claims9XgPTkogohNAfyx87Twt85q7h3lY87GJdYkEyeSdi70Meta || {}), ...{"middleware":["connector-required"]} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/claims.vue"),
    children: [
  {
    name: "claims-id",
    path: ":id()",
    meta: { ...(_91id_93G_tSX8e6JciSzKw6t9jgH5v5OUQFUl95VG_1lnjyX28Meta || {}), ...{"middleware":"connector-required"} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/claims/[id].vue"),
    children: [
  {
    name: "claims-id-insightId-influencing-claims",
    path: ":insightId()/influencing-claims",
    meta: { ...(influencing_45claims7P_45fQTPMzNRVG8bjF_450RIFlIa_IrZNx7RnCE2QV3kFEMeta || {}), ...{"middleware":"connector-required"} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/claims/[id]/[insightId]/influencing-claims.vue")
  }
]
  }
]
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: welcomea7_oKU1KpJgwNR_45v5XqnM0k53iWR5WMlxqKeP2Azy3QMeta || {},
    component: () => import("/opt/buildhome/repo/apps/console/pages/welcome.vue")
  },
  {
    name: policies49aZSYT3wSBIR_9E72mjq2rOiFsBfXw_45qUY2sAnVyVsMeta?.name,
    path: "/policies",
    meta: policies49aZSYT3wSBIR_9E72mjq2rOiFsBfXw_45qUY2sAnVyVsMeta || {},
    component: () => import("/opt/buildhome/repo/apps/console/pages/policies.vue"),
    children: [
  {
    name: "policies-id",
    path: ":id()",
    meta: { ...(_91id_93_45D6P3lJmAuWSAjCcipSBkmm9sHyBtMr2wTgC4PzLCvMMeta || {}), ...{"middleware":["connector-required"]} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/policies/[id].vue"),
    children: [
  {
    name: "policies-id-edit-modes",
    path: "edit-modes",
    meta: { ...(edit_45modes8UNPjnrLWCfiYh_456PqzvZH1qSgaR3L3mvtzYJ4MVYW8Meta || {}), ...{"middleware":["connector-required","policy-context-required"]} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/policies/[id]/edit-modes.vue")
  },
  {
    name: "policies-id-providers-impacted",
    path: "providers-impacted",
    meta: { ...(providers_45impacted5aWRtZE00wQfYoAh3lCaUoSUoTobxfUruJdCBNpimsIMeta || {}), ...{"middleware":"connector-required"} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/policies/[id]/providers-impacted.vue")
  }
]
  },
  {
    name: "policies",
    path: "",
    component: () => import("/opt/buildhome/repo/apps/console/pages/policies/index.vue")
  }
]
  },
  {
    name: "changelog",
    path: "/changelog",
    meta: { ...(changelogt0YH_456FtAcTmyiKADiWTBiO8Q5mgj7V6nvPAZSmz7_YMeta || {}), ...{"middleware":["connector-required"]} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/changelog.vue")
  },
  {
    name: "app-status",
    path: "/app-status",
    meta: app_45status4_45mCrI6Eo41iOEeBD920FPPSdyXxfqlp8XyEC1TIm7EMeta || {},
    component: () => import("/opt/buildhome/repo/apps/console/pages/app-status.vue")
  },
  {
    name: exclusionsOf0Z66avlKLdSxTFDW4Ub_6EogJtCMGED5ZA3nf3xMYMeta?.name,
    path: "/exclusions",
    meta: { ...(exclusionsOf0Z66avlKLdSxTFDW4Ub_6EogJtCMGED5ZA3nf3xMYMeta || {}), ...{"middleware":"connector-required"} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/exclusions.vue"),
    children: [
  {
    name: "exclusions",
    path: "",
    component: () => import("/opt/buildhome/repo/apps/console/pages/exclusions/index.vue")
  },
  {
    name: "exclusions-create",
    path: "create",
    meta: createKefaGeoyL3FOwj7GCah4lAqK_9o09R4tULxqqW21B9sMeta || {},
    component: () => import("/opt/buildhome/repo/apps/console/pages/exclusions/create.vue")
  },
  {
    name: "exclusions-id-edit",
    path: ":id()/edit",
    meta: edit0h5S3QhI_45lHkidV6aIUWcYjmPCEsUsclkGPLCeQQZL8Meta || {},
    component: () => import("/opt/buildhome/repo/apps/console/pages/exclusions/[id]/edit.vue")
  },
  {
    name: "exclusions-id",
    path: ":id()",
    meta: { ...(indexColiJcyFdAMg3nQK0hIO6ytNvrYQnMsADetGWlj82j4Meta || {}), ...{"middleware":"connector-required"} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/exclusions/[id]/index.vue")
  }
]
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexN8nA7obtLcYaJOfYzvi2rjWW0ipDWe_454B1E1mDUZ4ocMeta || {}), ...{"middleware":"rialtic-admin"} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/admin/index.vue"),
    children: [
  {
    name: "admin-index-create-workspace",
    path: "create-workspace",
    meta: { ...(create_45workspacet_45M3WklfcXo8HoA8R_ntEqF_451XMTwt52dCUkwl6QhzUMeta || {}), ...{"middleware":"rialtic-admin"} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/admin/index/create-workspace.vue")
  }
]
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: { ...(usersX5ckjacvzxUYx0_45TjbTwEYqiM_455J47qOTvfikcs4qsMMeta || {}), ...{"middleware":"rialtic-admin"} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/admin/users.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenanceSTLYaBEvR7Ok_7I7KTbB_23y3AWGSCYalNiJDzHcCrUMeta || {},
    component: () => import("/opt/buildhome/repo/apps/console/pages/maintenance.vue")
  },
  {
    name: "connectorId",
    path: "/:connectorId()",
    component: () => import("/opt/buildhome/repo/apps/claim-lab/pages/[connectorId].vue"),
    children: [
  {
    name: "connectorId-claim-lab",
    path: "claim-lab",
    component: () => import("/opt/buildhome/repo/apps/console/pages/[connectorId]/claim-lab/index.vue")
  },
  {
    name: "connectorId-claim-lab-claimId-rid",
    path: "claim-lab/:claimId()/:rid()",
    meta: { ...(_91rid_93FAVztuVrZRnW_45aTSK8wDSG5wyW2tTSc9zlj15dt_BVcMeta || {}), ...{"middleware":["claim-lab"]} },
    component: () => import("/opt/buildhome/repo/apps/claim-lab/pages/[connectorId]/claim-lab/[claimId]/[rid].vue")
  },
  {
    name: "connectorId-claim-lab-claimId-v2-rid",
    path: "claim-lab/:claimId()/v2/:rid()",
    meta: { ...(_91rid_93KkStUjosmYhKm4UmnjH3T8_H_V_grgKin58VALfOQMIMeta || {}), ...{"middleware":["claim-lab"]} },
    component: () => import("/opt/buildhome/repo/apps/claim-lab/pages/[connectorId]/claim-lab/[claimId]/v2/[rid].vue")
  }
]
  },
  {
    name: "account",
    path: "/account",
    meta: indexfYvy8GRk_w4yVSgDg87JvqkvcxYrExeH9IXiLqRKMSQMeta || {},
    component: () => import("/opt/buildhome/repo/apps/console/pages/account/index.vue")
  },
  {
    name: "account-users",
    path: "/account/users",
    meta: usersDMxviKARAq43c6oJBcW75_BVGsyiNKNA5l4q2H9nixIMeta || {},
    component: () => import("/opt/buildhome/repo/apps/console/pages/account/users.vue")
  },
  {
    name: "admin-api-admin",
    path: "/admin/api-admin",
    meta: { ...(api_45admin7kN5LSCREX600_YBE3ZALBbcBaZkc7422c94Gr8OGCUMeta || {}), ...{"middleware":"rialtic-admin"} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/admin/api-admin.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(indexDTgmlSr_45hOL3HEVH74EnR7mace4RjBWzZinmfjKOFOkMeta || {}), ...{"middleware":"all-connectors"} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/dashboard/index.vue")
  },
  {
    name: "admin-app-config",
    path: "/admin/app-config",
    meta: { ...(app_45config_Uu_EtjreTriHAx7K5LYmD7HOA_45i8j8S_45Bw6yqSicHMMeta || {}), ...{"middleware":"rialtic-admin"} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/admin/app-config.vue")
  },
  {
    name: "dashboard-policies",
    path: "/dashboard/policies",
    meta: { ...(policies1Q4jJxJfl06eD_45otAgf8tVxEvLi47qAR0L9c7Y0NLiQMeta || {}), ...{"middleware":"all-connectors"} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/dashboard/policies.vue"),
    children: [
  {
    name: "dashboard-policies-id",
    path: ":id()",
    meta: { ...(_91id_937rgB7bRJG5x32HSkszZUVPZhhcQaa_nSICn3WUwd98UMeta || {}), ...{"middleware":"all-connectors"} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/dashboard/policies/[id].vue")
  }
]
  },
  {
    name: "account-api-clients",
    path: "/account/api-clients",
    meta: { ...(api_45clientsZCaKP1RxHw1kpj_9p9rzlTGrf_xdarbyVHK2CKETbpMMeta || {}), ...{"middleware":["workspace-system-admin"]} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/account/api-clients.vue")
  },
  {
    name: _91id_93QpBcCbPIBHqZFUtSGZwclo2H_45RED0HqlM2FndVvgTFEMeta?.name,
    path: "/admin/workspace/:id()",
    meta: { ...(_91id_93QpBcCbPIBHqZFUtSGZwclo2H_45RED0HqlM2FndVvgTFEMeta || {}), ...{"middleware":"rialtic-admin"} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/admin/workspace/[id].vue"),
    children: [
  {
    name: "admin-workspace-id",
    path: "",
    component: () => import("/opt/buildhome/repo/apps/console/pages/admin/workspace/[id]/index.vue"),
    children: [
  {
    name: "admin-workspace-id-index-edit",
    path: "edit",
    component: () => import("/opt/buildhome/repo/apps/console/pages/admin/workspace/[id]/index/edit.vue")
  },
  {
    name: "admin-workspace-id-index-connector",
    path: "connector",
    component: () => import("/opt/buildhome/repo/apps/console/pages/admin/workspace/[id]/index/connector/index.vue")
  },
  {
    name: "admin-workspace-id-index-connector-connId",
    path: "connector/:connId()",
    component: () => import("/opt/buildhome/repo/apps/console/pages/admin/workspace/[id]/index/connector/[connId].vue")
  }
]
  }
]
  },
  {
    name: "dashboard-exclusions",
    path: "/dashboard/exclusions",
    meta: { ...(exclusionsu5Tg5lm4w5rAfAnHtCKdFlussXl5cycOkXr3FhFv_98Meta || {}), ...{"middleware":"all-connectors"} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/dashboard/exclusions.vue"),
    children: [
  {
    name: "dashboard-exclusions-id",
    path: ":id()",
    meta: { ...(indexEfG4fXJr_45PvDe00Xs0zxf97CCHIzKi60QmPGkdJ3_45ZIMeta || {}), ...{"middleware":"all-connectors"} },
    component: () => import("/opt/buildhome/repo/apps/console/pages/dashboard/exclusions/[id]/index.vue")
  }
]
  },
  {
    name: "admin-workspace",
    path: "/admin/workspace",
    meta: indexNC2qBDKoWLkn7K9gvLNL2ZxVwFJQr4lz3Y_45cEaj7KUcMeta || {},
    component: () => import("/opt/buildhome/repo/apps/console/pages/admin/workspace/index.vue")
  },
  {
    name: "dashboard-claim-search",
    path: "/dashboard/claim-search",
    meta: claim_45searchUBPrJWw1E9WXzEjV48VvnvrZswNEERd6LZuPQZs15IEMeta || {},
    component: () => import("/opt/buildhome/repo/apps/console/pages/dashboard/claim-search.vue")
  },
  {
    name: "legal-notice",
    path: "/legal/licensed-content-notice",
    meta: legalPXftdPkBk4BVypl5py2UNHmdRg_Jq1p0tUV3uPR7_7EMeta || {},
    component: () => import("/opt/buildhome/repo/packages/nuxt-auth0/src/runtime/pages/legal.vue")
  },
  {
    name: "auth-callback",
    path: "/auth/callback",
    meta: auth_45callbackOwXTNdlq9Gi79MczYvxUrBewH5fePFqTW3S9Tb8NMpUMeta || {},
    component: () => import("/opt/buildhome/repo/packages/nuxt-auth0/src/runtime/pages/auth-callback.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: auth_45loginLiuJ2aewqsIckj_8LP8r_45y2kg1aevC0phvVWWA5JLrQMeta || {},
    component: () => import("/opt/buildhome/repo/packages/nuxt-auth0/src/runtime/pages/auth-login.vue")
  },
  {
    name: "auth-status",
    path: "/auth/status",
    meta: auth_45statusdBnapL4nk9x52YjfnhmjwWHCTdX0TwuPmC1g8zjGa4kMeta || {},
    component: () => import("/opt/buildhome/repo/packages/nuxt-auth0/src/runtime/pages/auth-status.vue")
  }
]